export default "__VITE_ASSET__9LSoqAsN__"